import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {UncontrolledTooltip} from 'reactstrap';
import { useDispatch } from "react-redux";
import {addSongGuest} from "../../slices/event/song/add/thunk";

const VoteSongButton = ({eventSongListMetaData, isEventGuest, songId, eventId, guestId, setModalRegisterAndVoteOpen, setSongIdVote, requireTip, onPay}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const limitSongOnListPerUserReached = eventSongListMetaData.limitSongOnListPerUserReached ?? false;

  const handleClickItem = (e, songId, guestId) => {
    e.stopPropagation();
    if (!isEventGuest) {
      setModalRegisterAndVoteOpen(true);
      setSongIdVote(songId);
    } else if (requireTip) {
      // Wymagany napiwek: najpierw płatność, potem głos.
      onPay({song: {id: songId}, user: {id: guestId}, eventId: eventId});
    } else {
      dispatch(addSongGuest({song: {id: songId}, user: {id: guestId}, eventId: eventId}))
    }
  };

  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (tooltipOpen) {
      const timer = setTimeout(() => setTooltipOpen(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [tooltipOpen]);

  return (
    <>
      <div style={{display: 'inline-block'}} id='vote-song-button'>
        <button className="btn btn-sm btn-icon text-white"
                disabled={limitSongOnListPerUserReached}
                onClick={(e) => handleClickItem(e, songId, guestId)}
                style={limitSongOnListPerUserReached ? {pointerEvents: 'none'} : {}}
        >
          <i className="ri-thumb-up-line fs-20"></i>
        </button>
      </div>

      {limitSongOnListPerUserReached && (
        <UncontrolledTooltip
          placement="left"
          target="vote-song-button"
          trigger="click"
          isOpen={tooltipOpen}
          toggle={() => setTooltipOpen(!tooltipOpen)}
        >
          {t('Your votes limit on this list has been reached')}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default VoteSongButton;
